<template>
  <div
    id="sidebar-menu"
    v-if="!loading"
    style="
      border-top: 1px solid #eeeeee;
      border-right: 1px solid #eeeeee;
      margin-top: 11px;
    "
  >
    <v-list style="margin-top: -9px; margin-bottom: -16px">
      <template v-for="item in items">
        <v-list-group
          v-if="
            item.items.length > 0 && item.show && item.node_type === 'group'
          "
          :key="item.text"
          :prepend-icon="item.icon"
          :value="item.expand"
          no-action
        >
          <template v-slot:activator link :to="item.to">
            <v-list-item-content>
              <v-list-item-title v-text="$t(item.text)"></v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item
            v-for="child in item.items"
            :key="child.text"
            link
            :to="child.to"
            v-show="child.show"
            @click="updateOnClick(item)"
          >
            <v-list-item-content>
              <v-list-item-title v-text="$t(child.text)"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <v-list-group
          v-else-if="item.name == 'dashboard-goto-site'"
          v-model="goToSiteExpanded"
          :key="item.text"
          :prepend-icon="item.icon"
          :value="item.expand"
          no-action
        >
          <template v-slot:activator link :to="item.to">
            <v-list-item-content>
              <v-list-item-title v-text="$t(item.text)"></v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item
            v-for="(child, index) in installations"
            :key="`${child.installation_id}-${index}`"
            @click.prevent="openSiteChoice(child)"
          >
            <v-list-item-content>
              <v-list-item-title
                v-text="$t(child.installation_name)"
              ></v-list-item-title>
              <!-- <v-icon
                v-if="
                  siteFlags(child).isSmartguard && siteFlags(child).isHelioclean
                "
                small
                right
              >
                mdi-arrow-right-bold-box-outline
              </v-icon> -->
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <v-list-item
          v-else
          :key="item.text"
          v-show="item.show"
          link
          :to="item.to"
          @click="updateOnClick(item)"
        >
          <v-list-item-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title v-text="$t(item.text)"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>

    <v-list v-model="tpl_key">
      <v-divider v-if="showExpertModulesMenu"></v-divider>

      <v-list-group
        v-model="tpl_key"
        v-if="showExpertModulesMenu"
        color="white"
        no-action
        prepend-icon="mdi-microscope"
      >
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title>{{ $t("_modules_experts_") }}</v-list-item-title>
          </v-list-item-content>
        </template>

        <v-list-item
          nav
          v-for="item in changedexpertmodule()"
          :key="item.text"
          link
          class="border-bottom"
          :style="
            unablelist.includes(item.report_name)
              ? { backgroundColor: '#f5f5f5' }
              : {}
          "
          @click.prevent="
            !unablelist.includes(item.report_name) && handleClick(item)
          "
        >
          <v-list-item-content>
            <v-list-item-title>{{ item.text }}</v-list-item-title>
          </v-list-item-content>
          <v-icon
            v-if="testversion(item) && !unablelist.includes(item.report_name)"
            right
            style="color: #3a9ffd"
            >mdi-new-box</v-icon
          >
          <icon
            v-if="
              item.mode_ac &&
              !unablelist.includes(item.report_name) &&
              auditac == true
            "
            right
            style="color: green"
            :icon="checklistIcon['inv']['icon']"
            :height="checklistIcon['inv']['height']"
          />
          <span v-if="unablelist.includes(item.report_name)" class="icon-badge"
            >NA</span
          >
        </v-list-item>
      </v-list-group>
    </v-list>
    <v-dialog v-model="siteChoiceDialog" max-width="320">
      <v-card>
        <v-card-title>{{
          selectedSiteForChoice ? selectedSiteForChoice.installation_name : ""
        }}</v-card-title>
        <v-card-actions class="d-flex justify-space-around pb-4">
          <v-btn
            :disabled="!currentSiteFlags.isSmartguard"
            color="primary"
            @click="goToSite(selectedSiteForChoice, 'smartguard')"
          >
            SmartGuard
          </v-btn>
          <v-btn
            :disabled="!currentSiteFlags.isHelioclean"
            color="green"
            @click="goToSite(selectedSiteForChoice, 'helioclean')"
          >
            HelioClean
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import api from "../../api/api";
import store from "../../store";
import { Icon } from "@iconify/vue2";

export default {
  components: {
    Icon,
  },
  name: "SidebarMenu",

  data() {
    return {
      activatelist: false,
      loading: false,
      hasPdfReport: false,
      installation: null,
      checklistIcon: {},
      items: [],
      expertModules: [],
      expertModulesName: [],
      security_rules: null,
      showExpertModules: false,
      tpl_key: 0,
      lastversion: 1,
      unablelist: [],
      goToSiteExpanded: false,
      siteChoiceDialog: false,
      selectedSiteForChoice: null,
      helioCleanSitesMap: {},
      helioCleanSitesLoaded: false,
    };
  },

  mounted() {
    this.getChecklistIcon();
    this.created();
    this.fetchHelioCleanSites();
    this.$root.$on("close-go-to-site", () => {
      this.goToSiteExpanded = false;
    });
  },
  beforeDestroy() {
    this.$root.$off("close-go-to-site");
  },

  computed: {
    ...mapGetters(["role", "installations", "cur_install_id", "constants"]),

    auditac() {
      const inst =
        this.installation ||
        this.installations.find(
          (x) => x.installation_id === this.cur_install_id
        );
      return inst?.dc_analysis === false; // AC mode if dc_analysis is false
    },
    showExpertModulesMenu() {
      return this.showExpertModules && this.$route.name !== "helio-clean";
    },
    currentSiteFlags() {
      return this.selectedSiteForChoice
        ? this.siteFlags(this.selectedSiteForChoice)
        : { isSmartguard: false, isHelioclean: false };
    },
  },

  watch: {
    $route: {
      handler() {
        if (Object.keys(this.$route.params).length > 0) {
          this.installation = this.installations.find(
            (x) => x.id == this.cur_install_id
          );
        }
        this.loadMenu();
      },
      immediate: true,
      deep: true,
    },

    "$root.$i18n.locale": {
      handler() {
        this.loadMenu();
      },
    },

    cur_install_id: {
      handler() {
        // this.showExpertModules = (this.cur_install_id != null)
        // if (this.showExpertModules) this.getReportModules()
        this.loadMenu();
      },
    },
  },

  methods: {
    async created() {
      if (store.getters.authenticated) {
        await api.currentUser().then((res) => {
          this.security_rules = res["data"]["policies"];
          this.loadMenu();
        });
      }
    },

    async fetchHelioCleanSites() {
      try {
        const response = await api.getAllHelioCleanSites();
        const map = {};
        (response.data || []).forEach((site) => {
          map[site.installation_id] = site;
        });
        this.helioCleanSitesMap = map;
      } catch (error) {
        // No HelioClean sites configured yet, or request failed — treat as
        // "SmartGuard only" for every site rather than breaking the sidebar.
        console.error("Failed to fetch HelioClean sites:", error);
        this.helioCleanSitesMap = {};
      } finally {
        this.helioCleanSitesLoaded = true;
      }
    },

    siteFlags(item) {
      const site = this.helioCleanSitesMap[item.installation_id];
      return {
        isSmartguard: site ? site.is_smartguard : true,
        isHelioclean: site ? site.is_helioclean : false,
      };
    },

    openSiteChoice(item) {
      const flags = this.siteFlags(item);

      // Only one path available — just go there, no dialog needed
      if (flags.isSmartguard && !flags.isHelioclean) {
        return this.goToSite(item, "smartguard");
      }
      if (flags.isHelioclean && !flags.isSmartguard) {
        return this.goToSite(item, "helioclean");
      }

      // Both available — this is the only case that actually needs a choice
      this.selectedSiteForChoice = item;
      this.siteChoiceDialog = true;
    },

    goToSite(item, target) {
      this.$store.commit("SET_CUR_INSTALL_ID", item.installation_id);
      if (target === "smartguard") {
        this.$router.push(`/smart-guard/${item.installation_id}`);
      } else {
        this.$router.push(`/helio-clean/${item.installation_id}`);
      }
      this.siteChoiceDialog = false;
    },

    handleClick(item) {
      if (this.shouldNavigate(item)) {
        this.$router.push(item.to);
      }
    },

    shouldNavigate(item) {
      return !this.unablelist.includes(item.text);
    },

    getChecklistIcon() {
      this.$store.getters.constants["alarm"].forEach((checklist) => {
        this.checklistIcon[checklist.key] = checklist["icon"];
      });
    },

    securityCheck(item, policies) {
      if (policies) return policies[item] === true;
      return false;
    },

    additemsinstallations() {
      this.installations.forEach((element) => {
        this.items[2].items.push(element.installation_name);
      });
      return this.items;
    },

    getMenu() {
      return this.installations.find((x) => x.id == this.cur_install_id)
        ?.target_menu;
    },

    changedexpertmodule() {
      if (!this.installation) return [];

      const pacgrid = this.installation.elec_var.includes("Pac@grid");
      return this.expertModules.filter((module) => {
        const isAC = module.analysis_types?.includes("ac");
        const isDC = module.analysis_types?.includes("dc");

        if (this.auditac) {
          // AC mode
          if (!isAC) return false;
          if (pacgrid) {
            const excluded = [
              "bypass",
              "pvsyst",
              "3_niv3_Bypass",
              "incident",
              "kpi_filter",
            ];
            return !excluded.includes(module.report_name);
          }
          return true;
        } else {
          // DC mode
          return isDC;
        }
      });
    },

    testversion(item) {
      if (
        item.comp_min_version == this.lastversion ||
        item.comp_min_version == this.lastversion - 0.1
      ) {
        return true;
      } else {
        return false;
      }
    },

    loadMenu() {
      this.expertModules = [];
      this.expertModulesName = [];

      // if (this.items === undefined || this.items === null) return false
      this.refreshMenu();

      if (this.installation !== undefined && this.installation !== null) {
        this.hasPdfReport = this.installation.pdf_link.length > 0;
        this.showExpertModules =
          this.cur_install_id != null &&
          this.$route.name !== "helio-clean" &&
          this.$route.name != "dashboard-clean";

        if (this.showExpertModules) {
          this.getReportModules();
          this.createunablelist();
        }

        // Set Level 2 dates
        this.$store.dispatch("setInstallationNiv2Date", {
          start_date: this.installation.audit_start_date,
          end_date: this.installation.audit_end_date,
        });
      } else {
        this.hasPdfReport = false;
        this.showExpertModules = false;
      }
    },

    refreshMenu() {
      if (!this.security_rules) {
        return;
      }

      this.items = JSON.parse(JSON.stringify(this.constants.menu));

      for (let item in this.items) {
        const elm = this.items[item];
        let t = this.securityCheck(elm.name, this.security_rules);

        if (
          this.cur_install_id != null &&
          this.items[item].to.includes(":id")
        ) {
          const pattern = this.items[item].to;
          this.items[item].to = pattern.replace(
            ":id",
            String(this.cur_install_id)
          );
        }

        if (elm.name === "analyst_mod") {
          t = t && this.cur_install_id != null;
        } else if (elm.name === "pdf_report") {
          t = t && this.hasPdfReport && this.cur_install_id != null;
        }

        this.items[item].show = t;

        if (elm.items.length > 0) {
          for (let subitem in elm.items) {
            this.items[item].items[subitem].show = this.securityCheck(
              this.items[item].items[subitem].name,
              this.security_rules
            );
          }
        }

        // if (elm.name === "dashboard-parc") {
        //   this.items[item].show =
        //     this.security_rules["dashboard_parc"] === true &&
        //     ["admin", "data-analyst", "user-manager"].includes(
        //       this.$store.getters.role
        //     );
        // }
        if (elm.name === "dashboard-fleet") {
          this.items[item].show =
            this.security_rules?.dashboard_fleet === true &&
            ["admin", "data-analyst", "user-manager", "user"].includes(
              this.$store.getters.role
            );
        }
        if (elm.name === "dashboard-manager") {
          this.items[item].show =
            this.security_rules?.dashboard_manager === true &&
            ["admin", "data-analyst", "user-manager", "user"].includes(
              this.$store.getters.role
            );
        }

        if (elm.name === "dashboard-clean") {
          this.showExpertModules = false;
          this.items[item].show =
            this.security_rules?.dashboard_clean === true &&
            ["admin", "data-analyst", "user-manager", "user"].includes(
              this.$store.getters.role
            );
        }
      }
    },

    async createunablelist() {
      await api.getListunablemodexp(this.cur_install_id).then((response) => {
        this.unablelist = response.data;
      });
      this.unablelist = this.unablelist.map((element) => this.$t(element));
    },

    updateOnClick(item) {
      if (item.name !== "analyst_mod" && item.name !== "pdf_report") {
        this.$store.commit("SET_CUR_INSTALL_ID", null);
      }
    },

    async getReportModules() {
      let obj = {};
      this.expertModules = [];
      this.expertModulesName = [];

      await api
        .getReportModuleList(
          "expert-mod",
          this.installation.compute_tag_version
        )
        .then((res) => {
          res["data"].forEach((elm) => {
            if (elm["module_type"].includes("expert-img")) {
              obj = {
                icon: "mdi-application-variable-outline",
                text: this.$t(elm["module_name"]),
                to: `/expert-img/${this.cur_install_id}/${elm["report_name"]}`,
                report_name: elm["report_name"],
                comp_min_version: elm["comp_min_version"],
                comp_max_version: elm["comp_max_version"],
                mode_ac: elm["mode_ac"],
                target_menu: elm["target_menu"],
                analysis_types: elm["analysis_types"],
                last_version: elm["last_version"],
              };
              if (
                this.expertModules.filter((elm) => elm.text == obj.text)
                  .length === 0
              )
                this.expertModules.push(obj);
            } else if (
              elm["module_type"].includes("expert-layout") &&
              elm["target_menu"].includes(this.getMenu())
            ) {
              obj = {
                icon: "mdi-application-variable-outline",
                text: this.$t(elm["module_name"]),
                to: `/expert-layout/${this.cur_install_id}/${elm["report_name"]}`,
                report_name: elm["report_name"],
                comp_min_version: elm["comp_min_version"],
                comp_max_version: elm["comp_max_version"],
                mode_ac: elm["mode_ac"],
                target_menu: elm["target_menu"],
                analysis_types: elm["analysis_types"],
                last_version: elm["last_version"],
              };
              if (
                this.expertModules.filter((elm) => elm.text == obj.text)
                  .length === 0
              )
                this.expertModules.push(obj);
            } else if (
              elm["module_type"].includes("expert-pvsyst") &&
              elm["target_menu"].includes(this.getMenu())
            ) {
              obj = {
                icon: "mdi-application-variable-outline",
                text: this.$t(elm["module_name"]),
                to: `/expert-pvsyst/${this.cur_install_id}/${elm["report_name"]}`,
                report_name: elm["report_name"],
                comp_min_version: elm["comp_min_version"],
                comp_max_version: elm["comp_max_version"],
                mode_ac: elm["mode_ac"],
                target_menu: elm["target_menu"],
                analysis_types: elm["analysis_types"],
                last_version: elm["last_version"],
              };
              if (
                this.expertModules.filter((elm) => elm.text == obj.text)
                  .length === 0
              )
                this.expertModules.push(obj);
            } else if (
              elm["module_type"].includes("expert-kpi") &&
              elm["target_menu"].includes(this.getMenu())
            ) {
              obj = {
                icon: "mdi-application-variable-outline",
                text: this.$t(elm["module_name"]),
                to: `/expert-kpi/${this.cur_install_id}/${elm["report_name"]}`,
                report_name: elm["report_name"],
                comp_min_version: elm["comp_min_version"],
                comp_max_version: elm["comp_max_version"],
                mode_ac: elm["mode_ac"],
                target_menu: elm["target_menu"],
                analysis_types: elm["analysis_types"],
                last_version: elm["last_version"],
              };
              if (
                this.expertModules.filter((elm) => elm.text == obj.text)
                  .length === 0
              )
                this.expertModules.push(obj);
            } else if (
              elm["module_type"].includes("expert-incident") &&
              elm["target_menu"].includes(this.getMenu())
            ) {
              obj = {
                icon: "mdi-application-variable-outline",
                text: this.$t(elm["module_name"]),
                to: `/expert-incident/${this.cur_install_id}/${elm["report_name"]}`,
                report_name: elm["report_name"],
                comp_min_version: elm["comp_min_version"],
                comp_max_version: elm["comp_max_version"],
                mode_ac: elm["mode_ac"],
                target_menu: elm["target_menu"],
                analysis_types: elm["analysis_types"],
                last_version: elm["last_version"],
              };
              //              if (this.expertModules.filter((elm) => elm.text == obj.text).length === 0) this.expertModules.push(obj)
              //            } else if (elm['module_type'].includes('expert-kpi') && elm['target_menu'].includes(this.getMenu())) {
              //              obj = {
              //                "icon": "mdi-application-variable-outline",
              //                "text": this.$t(elm['module_name']),
              //                "to": `/expert-kpi/${this.cur_install_id}/${elm['report_name']}`,
              //                "report_name": elm['report_name']
              //                "comp_min_version": elm['comp_min_version'],
              //                "comp_max_version": elm['comp_max_version'],
              //                "mode_ac": elm['mode_ac'],
              //                "target_menu": elm['target_menu'],
              //                "module_type": elm['module_type']
              //                "analysis_types": elm['analysis_types'],
              //                "last_version": elm['last_version']
              //              }
              if (
                this.expertModules.filter((elm) => elm.text == obj.text)
                  .length === 0
              )
                this.expertModules.push(obj);
            } else if (
              elm["module_type"].includes("expert-mod") &&
              elm["target_menu"].includes(this.getMenu())
            ) {
              obj = {
                icon: "mdi-application-variable-outline",
                text: this.$t(elm["module_name"]),
                to: `/expert-mod/${this.cur_install_id}/${elm["module_name"]}/site`,
                report_name: elm["report_name"],
                comp_min_version: elm["comp_min_version"],
                comp_max_version: elm["comp_max_version"],
                mode_ac: elm["mode_ac"],
                target_menu: elm["target_menu"],
                analysis_types: elm["analysis_types"],
                last_version: elm["last_version"],
              };
              if (
                this.expertModules.filter((elm) => elm.text == obj.text)
                  .length === 0
              )
                this.expertModules.push(obj);
            }
          });
        });

      this.expertModules.sort((a, b) => (a.text > b.text ? 1 : -1));
      this.lastversion = this.expertModules[0]["last_version"];
    },
  },
};
</script>

<style lang="scss">
.v-list .v-list-item--active {
  color: #000 !important;
  border-right: 2px #f39200 solid;
  font-weight: bold;
}

.v-list-item__title {
  line-height: 0.9em;
  font-size: 0.9rem;
}

.v-list-item {
  min-height: 10px;
}

.v-application--is-ltr
  .v-list-group--no-action
  > .v-list-group__items
  > .v-list-item {
  padding-left: 25px;
}

.v-application--is-ltr .v-list-item__action:first-child,
.v-application--is-ltr .v-list-item__icon:first-child {
  margin-right: 15px;
}

.icon-badge {
  position: absolute;
  background-color: #9d9d9d;
  color: white;
  right: 10px;
  font-size: 10px;
  font-weight: bold;
  border-radius: 3px;
  padding: 2px 5px;
  text-transform: uppercase;
  white-space: nowrap;
}
</style>
